/**
 * Plan days the team grants a doctor for each verified referral.
 *
 * Display-only: nothing in the client applies the reward. Granting is a manual
 * step performed by the team — see docs/plans/2026-08-30-doctor-referrals.md.
 */
export const REFERRAL_REWARD_DAYS = 30
